import PlanCuentas from "./PlanCuentas";
export default PlanCuentas;